export default "__VITE_ASSET__Cl9d$AKN__"